import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { HomeService } from '../../../../services/home.service';
import { DeliveryService } from '../../../../services/delivery';
import { UserService } from '../../../../services/user';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-empolyeescollecting',
  templateUrl: './empolyeescollecting.component.html',
  styleUrl: './empolyeescollecting.component.scss'
})
export class EmpolyeescollectingComponent implements OnInit {

  months = [
    { value: '1', name_ar: 'يناير', name_en: 'January' },
    { value: '2', name_ar: 'فبراير', name_en: 'February' },
    { value: '3', name_ar: 'مارس', name_en: 'March' },
    { value: '4', name_ar: 'أبريل', name_en: 'April' },
    { value: '5', name_ar: 'مايو', name_en: 'May' },
    { value: '6', name_ar: 'يونيو', name_en: 'June' },
    { value: '7', name_ar: 'يوليو', name_en: 'July' },
    { value: '8', name_ar: 'أغسطس', name_en: 'August' },
    { value: '9', name_ar: 'سبتمبر', name_en: 'September' },
    { value: '10', name_ar: 'أكتوبر', name_en: 'October' },
    { value: '11', name_ar: 'نوفمبر', name_en: 'November' },
    { value: '12', name_ar: 'ديسمبر', name_en: 'December' }
  ];

  selectedMonth!: string;
  herosd!: any;
  date!: any;

  AllHeros: any[] = [];
  collectedFromDH: any[] = [];

  totalCollected: number = 0;
  totalCount: number = 0;

  currentPage: number = 1;
  lastPage: number = 1;

  contentReady: boolean = false;
  hasData: boolean = false;

  isAr: boolean = localStorage.getItem("language") == "ar";
  requestedEmployeeId: string | null = null;

  showDayCalendar: boolean = false;
  dayCalendarViewDate: Date = new Date();

  constructor(
    private _homeService: HomeService,
    private _deliveryhero: DeliveryService,
    private _userService: UserService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.requestedEmployeeId = this.route.snapshot.queryParamMap.get('employee_id');

    const today = new Date();
    this.date = this.formatDateForInput(today);
    this.dayCalendarViewDate = new Date(today.getFullYear(), today.getMonth(), 1);

    this.getAllUsers();
  }

  getAllUsers() {
    this.contentReady = true;

    this._homeService.getAllUsers().subscribe({
      next: (data: any) => {
        this.AllHeros = data
          .filter((user: any) =>
            ["3", "4", "5", "6", "7"].includes(user.type)
          )
          .reverse();

        if (this.AllHeros.length > 0) {
          const requestedHero = this.AllHeros.find(
            (user: any) => String(user.id) === String(this.requestedEmployeeId)
          );

          this.herosd = requestedHero?.id || this.AllHeros[0].id;
          this.getCollectedFromHero();
        }

        this.contentReady = false;
      },
      error: () => {
        this.contentReady = false;
      }
    });
  }

  getCollectedFromHero(page: number = 1) {
    this.contentReady = true;

    this._deliveryhero.getAllSalesCollections({
      user_id: this.herosd,
      date: this.selectedMonth ? "" : this.date,
      month: this.selectedMonth ? this.selectedMonth : "",
    }).subscribe({
      next: (res: any) => {

        this.collectedFromDH = res.data || [];
        this.currentPage = res.current_page || 1;
        this.lastPage = res.last_page || 1;

        this.recalcSummary();

        this.totalCount = this.collectedFromDH.length;
        this.hasData = this.collectedFromDH.length === 0;

        this.contentReady = false;
      },
      error: () => this.contentReady = false
    });
  }

  recalcSummary() {
    this.totalCollected = this.collectedFromDH
      .reduce((acc, item) => acc + Number(item.sales || 0), 0);
  }

  changePage(page: number) {
    if (page < 1 || page > this.lastPage) return;
    this.currentPage = page;
    this.getCollectedFromHero(page);
  }

  dayChange() {
    this.selectedMonth = "";
    this.getCollectedFromHero();
  }

  getByMonth() {
    this.getCollectedFromHero();
  }

  filterAllHeros() {
    this.getCollectedFromHero();
  }

  delete(id: any) {
    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "اه" : "YES",
      cancelButtonText: this.isAr ? "لا" : "No"
    }).then((result) => {
      if (result.isConfirmed) {
        this._deliveryhero.deleteDeliveryCollection(id).subscribe(() => {
          this.getCollectedFromHero(this.currentPage);
        });
      }
    });
  }

  /* ================================
     Day Calendar
     ================================ */

  toggleDayCalendar(): void {
    this.showDayCalendar = !this.showDayCalendar;

    if (this.showDayCalendar) {
      const selectedDate = this.parseDateOnly(this.date);
      const baseDate = selectedDate || new Date();

      this.dayCalendarViewDate = new Date(
        baseDate.getFullYear(),
        baseDate.getMonth(),
        1
      );
    }
  }

  closeDayCalendar(): void {
    this.showDayCalendar = false;
  }

  previousDayCalendarMonth(): void {
    this.dayCalendarViewDate = new Date(
      this.dayCalendarViewDate.getFullYear(),
      this.dayCalendarViewDate.getMonth() - 1,
      1
    );
  }

  nextDayCalendarMonth(): void {
    this.dayCalendarViewDate = new Date(
      this.dayCalendarViewDate.getFullYear(),
      this.dayCalendarViewDate.getMonth() + 1,
      1
    );
  }

  getDayCalendarTitle(): string {
    return new Intl.DateTimeFormat(this.isAr ? 'ar-EG' : 'en-US', {
      month: 'long',
      year: 'numeric',
    }).format(this.dayCalendarViewDate);
  }

  getDayCalendarWeekDays(): string[] {
    return this.isAr
      ? ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
      : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  }

  getDayCalendarDays(): Array<{
    date: Date;
    dayNumber: string;
    isCurrentMonth: boolean;
    isToday: boolean;
    isSelected: boolean;
    isDisabled: boolean;
  }> {
    const year = this.dayCalendarViewDate.getFullYear();
    const month = this.dayCalendarViewDate.getMonth();

    const firstDay = new Date(year, month, 1);
    const gridStart = new Date(year, month, 1 - firstDay.getDay());

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const selectedDate = this.parseDateOnly(this.date);

    return Array.from({ length: 42 }, (_, index) => {
      const date = new Date(gridStart);
      date.setDate(gridStart.getDate() + index);
      date.setHours(0, 0, 0, 0);

      return {
        date,
        dayNumber: this.isAr ? this.toArabicDigits(date.getDate()) : String(date.getDate()),
        isCurrentMonth: date.getMonth() === month,
        isToday: this.isSameDate(date, today),
        isSelected: selectedDate ? this.isSameDate(date, selectedDate) : false,

        // مبيعات الموظفين ممكن تحتاج تاريخ قديم، فمش بنقفل أيام
        isDisabled: false
      };
    });
  }

  selectDayCalendarDate(date: Date): void {
    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0);

    this.date = this.formatDateForInput(selectedDate);

    this.closeDayCalendar();
    this.dayChange();
  }

  getDayDisplay(): string {
    const selectedDate = this.parseDateOnly(this.date);

    if (!selectedDate) {
      return this.isAr ? 'اختار اليوم' : 'Select day';
    }

    return new Intl.DateTimeFormat(this.isAr ? 'ar-EG' : 'en-US', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(selectedDate);
  }

  private parseDateOnly(value: any): Date | null {
    if (!value) return null;

    const cleanValue = String(value)
      .replace('T', ' ')
      .replace('Z', '')
      .split('.')[0]
      .trim()
      .split(' ')[0];

    const match = cleanValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);

    if (!match) return null;

    return new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3])
    );
  }

  private isSameDate(first: Date, second: Date): boolean {
    return first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate();
  }

  private formatDateForInput(date: Date): string {
    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0'),
    ].join('-');
  }

  private toArabicDigits(value: string | number): string {
    return String(value).replace(/\d/g, (digit) => '٠١٢٣٤٥٦٧٨٩'[Number(digit)]);
  }

}